import { useEffect, useState } from 'react';

import { useScroll } from 'framer-motion';

export function useIsScrolledPast(scrollYNumber: number) {
    const { scrollY } = useScroll();
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        scrollY.onChange((y) => {
            if (y > scrollYNumber) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        });
    }, [scrollY, scrollYNumber]);

    return isScrolled;
}
